module.exports = __webpack_public_path__ + "img/c5ad546.png";